import mouseMove from '@mailobj-browser/front/js/events/types/mouseMove.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements, modifiers } from '../styles.js'
import * as utilities from '#utilities/js/styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

let timeout = null

const onMouseMove = object(listener, {
  type: mouseMove,
  passive,
  task: (
    element
  ) => {
    const container = one(`.${elements.animate}`, element)

    clearTimeout(timeout)

    container.classList.remove(utilities.modifiers.display.none)
    container.classList.add(modifiers.animate.fade_in)

    timeout = setTimeout(() => {
      container.classList.add(utilities.modifiers.display.none)
      container.classList.remove(modifiers.animate.fade_in)
    }, 2500, container)
  }
})

export default element => {
  onMouseMove.listen(element)
}